import { AccessDeniedException, NotFoundException, BadRequestException, LocalException, NetworkErrorException } from '~/helpers/errorHelper';
import AccessDenied from './AccessDenied';
import NotFound from './NotFound';
import BadRequest from './BadRequest';
import ServerError from './ServerError';
import LocalError from './LocalError';
import NetworkError from './NetworkError';

type TErrorProps = {
  error?: AccessDeniedException | NotFoundException | BadRequestException | LocalException | NetworkErrorException | Error | any;
  title?: string;
  btnLink?: string;
  btnText?: string;
  title403?: string;
  btnLink403?: string;
  btnText403?: string;
  title404?: string;
  btnLink404?: string;
  btnText404?: string;
  title400?: string;
  btnLink400?: string;
  btnText400?: string;
  title500?: string;
  btnLink500?: string;
  btnText500?: string;
}

const Error = (props: TErrorProps) => {

  if (props.error instanceof AccessDeniedException) {
    const accessDeniedProps: { title?: string; btnLink?: string; btnText?: string } = {};
    const title = props.title403 || props.title;
    if (title) accessDeniedProps.title = title;
    const btnLink = props.btnLink403 || props.btnLink;
    if (btnLink) accessDeniedProps.btnLink = btnLink;
    const btnText = props.btnText403 || props.btnText;
    if (btnText) accessDeniedProps.btnText = btnText;

    return <AccessDenied {...accessDeniedProps} />;
  }

  if (props.error instanceof NotFoundException) {
    const notFoundProps: { title?: string; btnLink?: string; btnText?: string } = {};
    const title = props.title404 || props.title;
    if (title) notFoundProps.title = title;
    const btnLink = props.btnLink404 || props.btnLink;
    if (btnLink) notFoundProps.btnLink = btnLink;
    const btnText = props.btnText404 || props.btnText;
    if (btnText) notFoundProps.btnText = btnText;

    return <NotFound {...notFoundProps} />;
  }

  if (props.error instanceof BadRequestException) {
    const badRequestProps: { title?: string; btnLink?: string; btnText?: string } = {};
    const title = props.title400 || props.title;
    if (title) badRequestProps.title = title;
    const btnLink = props.btnLink400 || props.btnLink;
    if (btnLink) badRequestProps.btnLink = btnLink;
    const btnText = props.btnText400 || props.btnText;
    if (btnText) badRequestProps.btnText = btnText;

    return <BadRequest {...badRequestProps} />;
  }

  if (props.error instanceof NetworkErrorException) {
    const networkErrorProps: { title?: string; btnLink?: string; btnText?: string } = {};
    if (props.title) networkErrorProps.title = props.title;
    if (props.btnLink) networkErrorProps.btnLink = props.btnLink;
    if (props.btnText) networkErrorProps.btnText = props.btnText;

    return <NetworkError {...networkErrorProps} />;
  }

  if (props.error instanceof LocalException) {
    const localErrorProps: { title?: string; btnLink?: string; btnText?: string } = {};
    const title = props.title || props.error?.message;
    if (title) localErrorProps.title = title;
    if (props.btnLink) localErrorProps.btnLink = props.btnLink;
    if (props.btnText) localErrorProps.btnText = props.btnText;

    return <LocalError {...localErrorProps} />;
  }

  const serverErrorProps: { title?: string; btnLink?: string; btnText?: string } = {};
  const title = props.title500 || props.title;
  if (title) serverErrorProps.title = title;
  const btnLink = props.btnLink500 || props.btnLink;
  if (btnLink) serverErrorProps.btnLink = btnLink;
  const btnText = props.btnText500 || props.btnText;
  if (btnText) serverErrorProps.btnText = btnText;

  return <ServerError {...serverErrorProps} />;
}

export default Error;